import React, { useContext } from 'react';

import Skeleton from '../../Skeleton';
import { dataHooks, sidebarSkins } from '../constants';
import { st, classes } from './SidebarSkeleton.st.css';
import { SidebarNextContext } from '../SidebarNextContext';

/** SidebarSkeletonItem */
const SidebarSkeletonItem = ({ isLong = false }) => {
  return <div className={st(classes.skeletonItem, { long: isLong })} />;
};

/** SidebarSkeleton */
const SidebarSkeleton = () => {
  const { skin } = useContext(SidebarNextContext);

  return (
    <div data-hook={dataHooks.skeleton} className={classes.container}>
      {skin === sidebarSkins.light ? (
        <div className={classes.lightSkeleton}>
          <Skeleton
            spacing="small"
            content={[
              { type: 'line', size: 'medium' },
              { type: 'line', size: 'large' },
            ]}
          />
          <Skeleton
            spacing="small"
            content={[
              { type: 'line', size: 'large' },
              { type: 'line', size: 'medium' },
              { type: 'line', size: 'large' },
              { type: 'line', size: 'medium' },
            ]}
          />
        </div>
      ) : (
        <div>
          <SidebarSkeletonItem />
          <SidebarSkeletonItem isLong />
          <SidebarSkeletonItem isLong />
          <div className={classes.separator} />
          <SidebarSkeletonItem />
          <SidebarSkeletonItem isLong />
          <SidebarSkeletonItem />
        </div>
      )}
    </div>
  );
};

SidebarSkeleton.displayName = 'SidebarSkeleton';

export default SidebarSkeleton;
